import { render, staticRenderFns } from "./Logs.vue?vue&type=template&id=642635ce"
import script from "./Logs.vue?vue&type=script&lang=js"
export * from "./Logs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('642635ce')) {
      api.createRecord('642635ce', component.options)
    } else {
      api.reload('642635ce', component.options)
    }
    module.hot.accept("./Logs.vue?vue&type=template&id=642635ce", function () {
      api.rerender('642635ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Logs.vue"
export default component.exports